import { render, staticRenderFns } from "./Datacenter.vue?vue&type=template&id=58ace810&scoped=true"
import script from "./Datacenter.vue?vue&type=script&lang=js"
export * from "./Datacenter.vue?vue&type=script&lang=js"
import style0 from "./Datacenter.vue?vue&type=style&index=0&id=58ace810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ace810",
  null
  
)

export default component.exports